import React, { PropTypes } from 'react';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import ProgressBar from '@bibliocommons/shared-progress-bar';
import RecentlyReturnedTitle from '../RecentlyReturnedTitle';
import BorrowingList from '../../shared/BorrowingList';
import RecentlyReturnedUtilityBar from '../RecentlyReturnedUtilityBar';
import ImmutablePropTypes from 'react-immutable-proptypes';
import RecentlyReturnedEmptyContentPanel from '../RecentlyReturnedEmptyContentPanel';
import RecentlyReturnedIsDisabledContentPanel from '../RecentlyReturnedIsDisabledContentPanel';
import RecentlyReturnedSummaryView from '../RecentlyReturnedSummaryView';
import RecentlyReturnedHistoryView from '../RecentlyReturnedHistoryView';
import RecentlyReturnedAddToShelf from '../RecentlyReturnedAddToShelf';
import Immutable from 'immutable';

import { BATCH_ACTIONS, BATCH_ADDED_TO_SHELF_WORKFLOW } from '../../../../constants/WorkflowConstants';

import './RecentlyReturned.scss';

class RecentlyReturned extends BcReactComponent {

  constructor(props) {
    super(props);
    let historyView = false;
    if (props.router.location.query.page || props.router.location.query.sort) {
      historyView = true;
    }
    this.state = {
      historyView
    };

    this.bindAll('enableBorrowingHistory', 'switchToHistoryView', 'renderBatchActionButtons', 'handleBatchAddToShelf');
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.currentView === 'small') {
      this.setState({
        historyView: true
      });
    }
  }

  enableBorrowingHistory() {
    this.props.accountActions.updateBorrowingHistorySetting(
      this.props.accountId,
      true
    );
  }

  switchToHistoryView() {
    this.setState({
      historyView: true
    });
  }

  getPrintURL() {
    const { search } = this.props.location;
    return `/v2/print/recentlyreturned${search}`;
  }

  handleBatchAddToShelf(items, shelfName) {
    const metadataIds = items
      .map(item => item.get('metadataId'))
      .toSet()
      .toList();

    this.props.shelfActions.batchAddToShelf({ metadataIds, shelfName });
    this.props.workflowActions.updateWorkflow(BATCH_ACTIONS, BATCH_ADDED_TO_SHELF_WORKFLOW, Immutable.Map({ shelfName, metadataIds }));
  }

  renderBatchActionButtons(itemsForAction) {
    return (
      <RecentlyReturnedAddToShelf
        itemsForAction={itemsForAction}
        handleBatchAddToShelf={this.handleBatchAddToShelf} />
    );
  }

  getSortOptions() {
    const sortOptions = this.props.sortOptions;
    if (!sortOptions) {
      return Immutable.List();
    }
    const defaultSort = sortOptions.indexOf('checkedoutDate') === -1 ? 'returnedDate' : 'checkedoutDate';
    const currentSort = this.props.router.location.query.sort || defaultSort;
    return sortOptions.reduce(
      (acc, val) =>
        acc.set(
          val,
          Immutable.Map({
            id: val,
            applied: val === currentSort
          })
        ),
      Immutable.Map()
    ).toList();
  }

  renderContent() {
    const { saveBorrowingHistoryEnabled, items, returnedItemsOnLastDate, recentlyReturnedPaging, RecentlyReturnedActions, isFetching, shelfActions } = this.props;

    if (saveBorrowingHistoryEnabled && recentlyReturnedPaging.get('count') === 0) {
      return <RecentlyReturnedEmptyContentPanel />;
    }

    if (!saveBorrowingHistoryEnabled) {
      return (<RecentlyReturnedIsDisabledContentPanel handleClick={this.enableBorrowingHistory} />);
    }

    const itemsSinceLastCheckout = items.filter((item, index) => index < returnedItemsOnLastDate);
    const defaultSort = this.props.sortOptions && this.props.sortOptions.indexOf('checkedoutDate') === -1 ? 'returnedDate' : 'checkedoutDate';

    return (
      <div className="title-row">
        <RecentlyReturnedTitle />
        <BorrowingList>
          <RecentlyReturnedUtilityBar
            sortEnabled={this.state.historyView}
            sortOptions={this.getSortOptions()}
            printURL={this.getPrintURL()}
            recentlyReturnedPaging={this.state.historyView ? recentlyReturnedPaging : null}
            totalCount={recentlyReturnedPaging.get('count')} />
          {this.state.historyView &&
            <RecentlyReturnedHistoryView
              items={items}
              totalCount={recentlyReturnedPaging.get('count')}
              renderBatchActionButtons={(itemsForAction) => this.renderBatchActionButtons(itemsForAction)}
              RecentlyReturnedActions={RecentlyReturnedActions}
              recentlyReturnedPaging={recentlyReturnedPaging}
              isFetching={isFetching}
              shelfActions={shelfActions}
              ratingsTransactions={this.props.ratingsTransactions}
              ratingsActions={this.props.ratingsActions}
              ratings={this.props.ratings}
              defaultSort={defaultSort} />
          }
          {!this.state.historyView &&
            <RecentlyReturnedSummaryView totalItems={recentlyReturnedPaging.get('count')} switchViews={this.switchToHistoryView} itemsSinceLastCheckout={itemsSinceLastCheckout} />
          }
        </BorrowingList>
      </div>
    );
  }

  render() {
    const { isFetching } = this.props;
    return (
      <div className="cp-recentlyreturned">
        <ProgressBar active={isFetching} />
        {this.renderContent()}
      </div>
    );
  }
}

RecentlyReturned.propTypes = {
  user: ImmutablePropTypes.map,
  recentlyReturnedPaging: ImmutablePropTypes.map,
  sortOptions: ImmutablePropTypes.list,
  saveBorrowingHistoryEnabled: PropTypes.bool,
  items: ImmutablePropTypes.list,
  returnedItemsOnLastDate: PropTypes.number,
  workflowActions: PropTypes.objectOf(PropTypes.func),
  shelfActions: PropTypes.objectOf(PropTypes.func),
  isFetching: React.PropTypes.bool,
  currentView: PropTypes.string,
  listPresentationActions: PropTypes.objectOf(PropTypes.func),
  RecentlyReturnedActions: PropTypes.objectOf(PropTypes.func),
  accountActions: PropTypes.objectOf(PropTypes.func),
  accountId: PropTypes.number,
  ratingsTransactions:  ImmutablePropTypes.map,
  ratings: ImmutablePropTypes.map,
  ratingsActions:  PropTypes.objectOf(PropTypes.func)
};


export default RecentlyReturned;



// WEBPACK FOOTER //
// ./app/components/borrowing/recentlyreturned/RecentlyReturned/RecentlyReturned.jsx